var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 212,
    viewBox: "0 0 1440 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 208.692V3.30819H19.3008L90.9899 107.516L162.679 3.30819H181.98V208.692H159.922V46.3147L91.5413 145.285H90.4384L22.0581 45.7633V208.692H0Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217.531 208.692L292.529 3.30819H316.242L391.239 208.692H368.078L350.432 158.518H258.615L240.693 208.692H217.531ZM265.784 137.841H342.711L304.385 29.2224L265.784 137.841Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.903 208.692V3.30819H497.489C537.745 3.30819 564.766 28.671 564.766 66.1638C564.766 95.3862 548.499 116.889 522.305 125.16L570.281 208.692H544.363L499.143 128.744H448.961V208.692H426.903ZM448.961 108.068H498.592C525.062 108.068 542.708 92.078 542.708 65.8882C542.708 39.974 525.062 23.9844 498.592 23.9844H448.961V108.068Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M611.812 208.692V3.30819H633.871V115.235L732.305 3.30819H759.878L683.501 90.1482L764.841 208.692H738.371L668.337 107.516L633.871 146.663V208.692H611.812Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M885.892 212C827.989 212 786.079 167.615 786.079 106.138C786.079 44.6606 827.989 0 885.892 0C927.527 0 957.857 25.6385 968.059 51.277L947.379 60.3745C936.901 36.3901 915.119 20.6762 885.892 20.6762C840.397 20.6762 808.137 55.1365 808.137 106.138C808.137 157.139 840.397 191.324 885.892 191.324C915.119 191.324 936.901 175.886 947.379 151.901L968.059 160.999C957.857 186.637 927.527 212 885.892 212Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.6 208.692L994.597 3.30819H1016.93L1065.73 178.918L1115.64 3.30819H1139.08L1188.71 178.367L1237.51 3.30819H1259.85L1200.84 208.692H1177.4L1127.22 32.8062L1077.04 208.692H1053.6Z",
    fill: "black",
    fillOpacity: 0.02
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.25 208.692V113.306L1274.29 3.30819H1298.83L1357.28 92.3537L1415.46 3.30819H1440L1368.31 113.306V208.692H1346.25Z",
    fill: "black",
    fillOpacity: 0.02
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/Name.bc59561d192aa775d1dff0af7c2dfe24.svg";
export { ForwardRef as ReactComponent };